import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { isNumber, zl, zaokr } from '../../../functions/utilities';

const MieszkaniecSaldo = props => {

    const { tablicaCzynsze, tablicaPrzelewy_g, procent } = props;

    const [tablicaCzynszeAkt, setTablicaCzynszeAkt] = useState([]);

    const [sumaNaleznosci, setSumaNaleznosci] = useState(0);
    const [sumaPrzelewow, setSumaPrzelewow] = useState(0);

    useEffect( () => {
        setTablicaCzynszeAkt( tablicaCzynsze?.temp_msc?.length === 1 ? tablicaCzynsze?.temp_msc : tablicaCzynsze?.temp_msc?.slice(0, tablicaCzynsze?.temp_msc?.length-1) )
    },[tablicaCzynsze]);

    useEffect( () => {
        let temp = 0;
        if (tablicaCzynszeAkt?.length > 1) {
            for (let i = 0; i < tablicaCzynszeAkt.length; i++) {
                temp += tablicaCzynszeAkt[i].czynsz_na_msc;
            }
        } else if (tablicaCzynszeAkt?.length == 1) {
            temp = tablicaCzynszeAkt[0].czynsz_na_msc;
        }
        setSumaNaleznosci(temp)
    },[tablicaCzynszeAkt]);
    
    useEffect( ()  => { 
        let temp = 0;
        tablicaPrzelewy_g?.forEach( e => temp += e.kwota);
        setSumaPrzelewow(temp)
    },[tablicaPrzelewy_g]);

    const [saldo, setSaldo] = useState(0);

    useEffect( () => setSaldo( sumaPrzelewow - (sumaNaleznosci + (procent?.saldo || 0)) ), [sumaNaleznosci, sumaPrzelewow, procent]);

    const data = format(new Date(), 'dd-MM-yyyy');

    const opis = () => {
        if (isNumber(saldo)) {
            if (parseFloat(zaokr(saldo)) > 0)
                return `występuje nadpłata w wysokości ${zl(saldo)}.`;
            else if (zaokr(saldo) == 0)
                return `saldo wynosi 0 zł.`;
            else if (zaokr(saldo) < 0)
                return `występuje niedopłata w wysokości ${zl(saldo)}.`;
        } else return "";
    }

    return (
        <div className='saldo'>
            <h4>
                Saldo
            </h4>  
            {
                tablicaCzynsze && (
                    <span>Na dzień {data} na koncie {opis()}</span>
                )
            }
        </div> 
    )
}

export default MieszkaniecSaldo;